<template>
  <div class="follow-section">
    <div class="share-wrapper" style="margin: 30px auto 0">
      <div @click="clickedShareButton"  class="share-area">
        <p class="text">Paylaş</p>
        <social-sharing :url="url" inline-template>
          <div class="user-socialmedia-icons">
            <network network="facebook" style="cursor: pointer;">
              <img  style="width: 26px; height: 26px; border-radius: 50%" src="https://gcdn.bionluk.com/site/cicons/png/facebook.png"/>
            </network>

            <network  network="twitter" style="cursor: pointer; margin-left: 20px;">
              <img style="width: 26px; height: 26px; border-radius: 50%" src="https://gcdn.bionluk.com/site/cicons/png/twitter.png"/>
            </network>

            <network network="linkedin" style="cursor: pointer; margin-left: 20px;">
              <img style="width: 26px; height: 26px; border-radius: 50%" src="https://gcdn.bionluk.com/site/cicons/png/linkedin.png"/>
            </network>
          </div>
        </social-sharing>
        <div @click="copyToClipboard()" style="margin-left: 20px;">
          <img  class="share-icon" style="width: 26px; height: 26px; border-radius: 50%; cursor: pointer" src="https://gcdn.bionluk.com/site/cicons/png/link.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ShareInternalUserSection",
    props: {
      userProfile: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        url: window.location.href
      }
    },
    methods: {
      copyToClipboard(){
        const el = document.createElement('textarea');
        el.value = 'https://bionluk.com/'+this.userProfile.username;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.$toasted.global.infoToast({description: 'Profil linki kopyalandı.'});
      },
      clickedShareButton(){
        this.Helper.trackEvents.customEvent("clicked", {version:'v1', page:this.$store.state.componentMap.page, what:'portfolio share buttons'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  .follow-section{
    width: 393px;
    height: 86px;
    border-radius: 5px;
    border: solid 1px #eaedf2;
    background-color: #ffffff;
    .follow-section-button {
      width: 290px;
      height: 56px;
      border-radius: 2px;
      border: solid 1px #bfc8d2;
      cursor: pointer;
      .text {
        font-size: 18px;
        color: #2d3640;
        line-height: 56px;
        font-weight: 600;
      }
    }
    .share-wrapper {
      width: 240px;
      height: 26px;
      .share-area{
        display: flex;
        .user-socialmedia-icons {
          display: flex;
          flex-direction: row;
          height: 26px;
        }
        .text{
          margin-right: 20px;
          font-size: 18px;
          font-weight: normal;
          line-height: 1.33;
          color: #8b95a1;
        }
      }
    }
  }
</style>
